import {useRef} from 'react';
import {useDrag, useDrop} from 'react-dnd';

export const DraggableTile = ({widgetKey, column, index, moveTile, children}) => {
  const containerRef = useRef(null);

  const [{isDragging}, connectDrag, connectDragPreview] = useDrag({
    type: 'HR_DASHBOARD_TILE',
    item: () => ({widgetKey, column, index}),
    collect: monitor => ({isDragging: monitor.isDragging()})
  });

  const [, connectDrop] = useDrop({
    accept: 'HR_DASHBOARD_TILE',
    hover(item) {
      if (item.widgetKey === widgetKey) return;

      moveTile({
        fromColumn: item.column,
        fromIndex: item.index,
        toColumn: column,
        toIndex: index
      });

      item.column = column;
      item.index = index;
    }
  });

  connectDrag(connectDragPreview(connectDrop(containerRef)));

  return (
    <div
      ref={containerRef}
      className={`HRDashboardTile ${isDragging ? 'HRDashboardTile--dragging' : ''}`}
    >
      <div className='HRDashboardTile-dragHandle'>
        <i className='material-symbols-solid'>{'drag_indicator'}</i>
      </div>
      {children}
    </div>
  );
};

export const Column = ({column, moveTile, tileCount, className, children}) => {
  const [, connectDrop] = useDrop({
    accept: 'HR_DASHBOARD_TILE',
    hover(item, monitor) {
      if (!monitor.isOver({shallow: true})) return;
      if (item.column === column) return;

      moveTile({
        fromColumn: item.column,
        fromIndex: item.index,
        toColumn: column,
        toIndex: tileCount
      });

      item.column = column;
      item.index = tileCount;
    }
  });

  return <div ref={connectDrop} className={className}>{children}</div>;
};
